/** 管理画面の概算表示用。日本銀行 2026-09-04 17:00 JST（156.29-30円）を丸めた値。 */
export const USD_TO_JPY_ESTIMATE = 156;
export const USD_TO_JPY_ESTIMATE_DATE = '2026/9/4';

export function formatApproxJpy(usd: number): string {
  const yen = Math.max(0, usd * USD_TO_JPY_ESTIMATE);
  const fractionDigits = yen === 0 ? 0 : yen < 1 ? 2 : yen < 100 ? 1 : 0;
  return `約${yen.toLocaleString('ja-JP', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits })}円`;
}
